import React from 'react';
import { getIsSSR } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
export const DevToolsPanel = React.lazy(() => import(/* webpackChunkName: "wc-dev-tools-panle" */ './dev-tools-panel'));
const DebugButton = () => {
    const { resourceId } = useConfiguration();
    const { toggle, enabled, isSSR } = useApi((state, _a, _h, ctx) => ({
        enabled: resourceId === ctx.wcDevToolsState.panelIsOpenForResource,
        toggle: () => ctx.wcDevToolsApi.set('panelIsOpenForResource', resourceId === ctx.wcDevToolsState.panelIsOpenForResource ? null : resourceId),
        isSSR: getIsSSR(state),
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { style: {
                border: '1px solid #999',
                borderTop: '0px',
                padding: '0px 10px 3px',
                opacity: '0.5',
                backgroundColor: '#ccc',
                borderRadius: '0 0 6px 6px',
                textAlign: 'center',
                position: 'absolute',
                top: '0',
                left: '50%',
                marginLeft: '-50px',
                cursor: 'pointer',
                zIndex: 100,
            }, onClick: toggle }, "comments debug"),
        !isSSR && enabled && (React.createElement(React.Suspense, { fallback: null },
            React.createElement(DevToolsPanel, { toggle: toggle })))));
};
export default DebugButton;
//# sourceMappingURL=debug-button.js.map